import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { OrganizationsService } from '@app/services/organizations.service';
import { PartnerService } from '../../../services/partner.service';

import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { IModalComponent, IModalData } from '@app/interfaces';
import { Organization } from '@app/interfaces/accounts_list';
import { CurRadioOptions } from '@app/modules/onboarding/interfaces/onboarding.interface';
import { IPermissionsTreeOutput } from '@modules/shared/components/onboarding-permissions-tree/onboarding-permissions-tree.component';
import { PartnerAccount } from '../../../interfaces/partner-accounts.interface';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { availableRegions } from '@app/constants/available-regions';

enum PermissionLevel {
	custom = 'Custom',
}

export interface IRemoveTopicOptions {
	row: PartnerAccount;
	resellerId: string;
}

@Component({
	selector: 'app-partner-reonboard-accout-modal',
	templateUrl: './partner-reonboard-accout-modal.component.html',
	styleUrls: ['./partner-reonboard-accout-modal.component.scss'],
})
export class PartnerReonboardAccoutModalComponent implements IModalComponent<IRemoveTopicOptions>, OnInit {
	@Input() data: IModalData<IRemoveTopicOptions>;

	permissionLevel = PermissionLevel;
	curSelectOptions = CurRadioOptions;

	resellerId: string;

	form = new FormGroup({
		//
		permissionLevel: new FormControl(),
		curSelect: new FormControl(),
		curBucketName: new FormControl(),
	});

	isLoading$ = new BehaviorSubject<boolean>(false);

	permissionsSubject$ = new Subject<boolean>();
	selectedStep = 0;
	permissions: any;
	featuresList: string[];
	organization: Organization;

	availableRegions = availableRegions;

	get curRadio(): AbstractControl {
		return this.form.controls['curSelect'];
	}

	get curBucketName(): AbstractControl {
		return this.form.controls['curBucketName'];
	}

	constructor(
		private partnerService: PartnerService,
		private orgService: OrganizationsService,
		private toastService: WrapToasterService,
	) {}

	get permission(): AbstractControl {
		return this.form.get('permissionLevel');
	}

	ngOnInit() {
		this.resellerId = this.data.options.resellerId;
		this.orgService.getOrganizations().subscribe({
			next: (organizations) => {
				this.organization = organizations.find((item) => item.org_id === Number(this.data.options.row['org_id']));
			},
		});
		this.initForm();
	}

	initForm(): void {
		this.form = new FormGroup({
			permissionLevel: new FormControl(this.permissionLevel.custom),
			curSelect: new FormControl(CurRadioOptions.notMaster),
			region: new FormControl('us-east-1'),
			curBucketName: new FormControl(''),
		});
	}

	generateLinks() {
		this.isLoading$.next(true);
		const permissions: any = this.permissions;
		const features_list: any = this.featuresList;
		const bucketName = this.curRadio.value !== CurRadioOptions.notMaster ? this.curBucketName.value : '';
		const curExists = this.curRadio.value === CurRadioOptions.yesEnabled;

		const options = {
			reseller_id: this.resellerId,
			permissions,
			features_list,
			cur_bucket_name: bucketName,
			is_reonboard: true,
			permissionsLevel: 'Custom',
			has_existing_cur: curExists,
			accountsNames: [this.data.options.row['alias']],
			accountsUuids: [this.data.options.row['uuid']],
			organization: this.organization,
			region: this.form.controls['region'].value,
		};

		this.partnerService.generateLinks(options).subscribe(
			() => {
				setTimeout(() => {
					this.toastService.showToast('success', 'Success', `CFN links successfully generated.`);
					this.closeEvent({ message: 'linksGenerated' });
				}, 500);
			},
			(_) => {
				setTimeout(() => {
					this.toastService.showToast('error', 'Failure', 'An error has occurred during CFN link generation');
					this.closeEvent({ message: 'linksGenerated' });
				}, 500);
			},
		);
	}

	stepChanged(event: StepperSelectionEvent) {
		this.selectedStep = event.selectedIndex;

		if (this.selectedStep === 1) {
			this.permissionsSubject$.next(true);
		}
	}

	collectPermissions(event: IPermissionsTreeOutput) {
		this.permissions = event.permissionsAndFeatures.permissions;
		this.featuresList = event.permissionsAndFeatures.featuresList;
	}

	closeEvent(e?: {}): void {}
}
